import React, {useEffect} from "react";

import {useIncidentsQuery, useIncidentTotalsQuery} from "../query";
import IncidentsTable from "./index";
import useDataTableSorting from "../../../../components/DataTable/useDataTableSorting";
import useDataTablePagination from "../../../../components/DataTable/useDataTablePagination";
import IncidentTotals from "../../../../components/IncidentTotals";



const initialSorting = [{id: "datetime", desc: true}];


const TableDataLoader = ({filterState, filterProps, incidentRegistry, incidentSettings, map, dataTableId, ...props}) => {
    const sortingState = useDataTableSorting(initialSorting);
    const paginationState = useDataTablePagination({dataTableId});

    // Go to first page when the filters change or the sorting changes
    useEffect(() => {
        paginationState.goToFirstPage();
    }, [filterState?.filters, sortingState?.sorting, map.selectedFeatureIds]);

    const id__in = map.selectedFeatureIds.join(",")

    const fetchDataOptions = {
        ...paginationState.paginationFetchOptions,
        ...filterState.filterFetchOptions,
        ...sortingState.sortingFetchOptions,
        id__in
    }

    const exportFetchDataOptions = {
        ...filterState.filterFetchOptions,
        ...sortingState.sortingFetchOptions,
        id__in
    }

    const tableState = {
        ...paginationState,
        ...sortingState,
        ...filterState,
    }

    const dataQuery = useIncidentsQuery(fetchDataOptions);
    const incidentTotalsQuery = useIncidentTotalsQuery(exportFetchDataOptions);

    return <>
        <IncidentsTable rows={dataQuery.data?.rows}
                        incidentRegistry={incidentRegistry.data}
                        incidentSettings={incidentSettings.data}
                        page_count={dataQuery.data?.page_count}
                        loading={(dataQuery.isFetching && dataQuery.isPreviousData) || incidentRegistry.isFetching}
                        filterProps={filterProps}
                        map={map}
                        {...tableState}
                        dataTableId={dataTableId}
                        {...props}/>
        <IncidentTotals totals={incidentTotalsQuery.data} allStatisticsPath={'/public/incidents/analytics'}/>
    </>
}


export default TableDataLoader;